import * as React from 'react';

const PublishCourseImage = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={500}
    height={372}
    viewBox="0 0 500 372"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g clipPath="url(#prefix__clip0)">
      <path
        d="M209.315 369.591s-.179-.982-.268-2.32c-.089-1.339-.178-3.034 0-4.283.089-1.339.446-2.945.803-4.283.357-1.339.714-2.231.714-2.231.089-.089 1.071.089 1.071.268 0 0-.09.981-.179 2.32-.089 1.338-.268 2.944-.357 4.193a64.328 64.328 0 00-.446 4.105c-.089 1.338-.178 2.32-.178 2.32-.179 0-1.071.089-1.16-.089zM222.698 370.037s-.178-.982-.357-2.41c-.178-1.338-.178-3.123-.089-4.461.178-1.339.535-3.034.981-4.372.447-1.339.803-2.231.803-2.231.09-.089 1.071.178.982.268 0 0-.179.981-.357 2.32-.178 1.338-.268 2.944-.446 4.193a60.022 60.022 0 00-.446 4.194c-.089 1.339-.179 2.32-.179 2.32.09.268-.803.357-.892.179zM235.457 368.698s-.179-.714-.268-1.695c-.178-.982-.268-2.142-.178-3.123.089-.982.267-2.142.535-3.123.268-.982.446-1.696.446-1.696 0-.089 1.071.09 1.071.179v1.695c0 .982.089 2.142 0 3.034-.089.892-.179 2.052-.268 3.034-.089.981-.178 1.695-.178 1.695-.179.09-1.071.179-1.16 0z"
        fill="#3A4961"
      />
      <path
        d="M489.561 371.465S349.839 372 259.904 372c-89.936 0-229.658-.535-229.658-.535-4.818 0-4.64-1.071 0-1.071 0 0 139.722-.536 229.658-.536 89.935 0 229.657.536 229.657.536 4.729.089 4.64.981 0 1.071z"
        fill="#3A4961"
      />
      <path
        d="M109.091 26.643c5.374-4.004 7.893-9.717 5.626-12.76-2.267-3.042-8.461-2.263-13.835 1.74-5.374 4.004-7.892 9.717-5.626 12.76 2.267 3.043 8.461 2.264 13.835-1.74zM56.745 370.572c5.978-39.708 43.184-96.458 158.815-149.104 115.632-52.645 199.144-26.412 169.254 61.658-29.889 88.07-29.8 88.07-29.8 88.07l-298.269-.624z"
        fill="#172845"
      />
      <path
        d="M16.774 255.019C-13.651 208.263-6.96 115.642 73.25 62.282 102.248 42.92 173.537 9.995 219.218 8.834c99.304-2.588 113.758 70.224 84.048 122.245-29.711 52.021-42.024 79.95-108.941 122.87-66.916 42.919-135.617 65.405-177.551 1.07z"
        fill="#172845"
      />
      <path
        d="M331.103 189.524c4.729-38.993 33.904-58.267 54.247-57.642 48.715 1.428 31.763 51.129 21.324 62.996-10.439 11.868-24.09 27.483-39.258 31.945-16.06 4.729-37.919-24.271-36.313-37.299z"
        fill="url(#prefix__paint0_linear)"
      />
      <path
        d="M147.573 220.487c60.807 0 110.1-49.298 110.1-110.11S208.38.267 147.573.267c-60.806 0-110.1 49.298-110.1 110.11s49.294 110.11 110.1 110.11z"
        fill="url(#prefix__paint1_radial)"
      />
      <path
        d="M330.121 218.613c14.008 24.449 22.752 53.717 22.752 94.584 0 40.867-12.045 57.375-48.805 57.375-66.738 0-114.382 8.923-94.664-39.975 19.718-48.898 43.897-82.003 60.046-96.904 16.15-14.901 46.663-39.618 60.671-15.08z"
        fill="url(#prefix__paint2_linear)"
      />
      <path
        d="M251.963 371.197c11.509-.089 24.536-.625 38.544-.625 31.763 0 42.202-16.507 42.202-57.375 0-40.956-14.543-74.061-39.793-74.15-5.086 0 15.257-27.84 12.134-29.357-12.759 4.016-26.499 15.526-35.6 24.003-16.149 14.902-40.328 48.006-60.046 96.904-14.097 34.711 5.889 40.332 42.559 40.6z"
        fill="url(#prefix__paint3_linear)"
      />
      <path
        d="M236.795 287.142c-36.759-11.957-105.014-40.689-132.851-38.28-27.927 2.41-55.764 30.249-22.395 61.926 33.369 31.677 71.467 60.409 82.352 60.409h68.879c12.848 0 49.251-6.068 42.827-30.963-6.424-24.806-17.577-41.046-38.812-53.092z"
        fill="url(#prefix__paint4_linear)"
      />
      <path
        d="M164.882 286.25c-19.183-10.886-25.517-27.929-64.597-36.941-26.588 4.461-50.588 31.23-18.736 61.479 33.369 31.677 71.467 60.409 82.352 60.409h68.879c9.012 0 32.834-5.354 42.202-15.615-44.7-38.459-93.058-59.606-110.1-69.332z"
        fill="url(#prefix__paint5_linear)"
      />
      <path
        d="M257.227 335.415s-.892-.268-2.409-.803c-1.517-.536-3.569-1.249-5.978-2.231-4.729-1.874-10.35-4.64-14.632-7.049-4.283-2.409-9.636-5.622-14.008-8.209-4.283-2.588-7.584-4.462-7.584-4.462-.446-.268 0-1.16.535-.981 0 0 3.48 1.695 7.852 4.015 4.461 2.32 9.904 5.354 14.186 7.763 4.283 2.32 9.725 5.354 14.276 7.406 2.23 1.071 4.282 1.874 5.71 2.499 1.427.535 2.32.892 2.32.892.535.357.178 1.249-.268 1.16z"
        fill="#172845"
      />
      <path
        d="M236.795 287.142c-36.759-11.957-105.014-40.689-132.851-38.28-1.339.09-2.766.268-4.105.536-.356.089-.803.178-1.16.178-.178 0-.446.089-.624.179l-1.07.267c-.18.09-.358.09-.625.179-.536.089-.982.268-1.517.446h-.09c-.535.178-1.07.357-1.605.446-.179.089-.268.089-.446.179-.447.178-.803.267-1.25.446-.178.089-.267.089-.446.178-10.974 4.105-20.342 12.046-23.554 22.308 4.729-4.729 9.904-18.114 27.837-18.382 17.934-.267 21.859 3.748 27.748 6.336.625.267 1.16.535 1.785.803 3.925 1.695 24.089 13.563 28.104 15.08 0 0-6.245-7.139-9.546-9.816-5.264-4.283 13.205 3.659 19.629 6.068 12.312 4.64 23.554 14.634 36.224 18.203 13.205 3.748 26.855 6.514 40.596 7.049 4.461.179 8.922.089 13.294-.268-4.551-4.55-9.993-8.566-16.328-12.135z"
        fill="url(#prefix__paint6_linear)"
      />
      <path
        d="M180.764 245.918c-16.596-16.686-.268-86.464 8.119-76.916 8.387 9.458 19.718 21.772 19.986 45.596.267 23.825-8.566 41.492-28.105 31.32z"
        fill="url(#prefix__paint7_linear)"
      />
      <path d="M203.515 241.099l-48.001-74.685 17.934-16.954 32.655 41.313c0-.089 31.317 77.898-2.588 50.326z" fill="url(#prefix__paint8_linear)" />
      <path
        d="M206.103 190.684l-13.384-16.865c.625 2.053.982 4.194 1.16 6.336.357 5.264 1.874 27.036-12.045 27.215l21.681 33.818c33.905 27.483 2.588-50.504 2.588-50.504z"
        fill="url(#prefix__paint9_linear)"
      />
      <path
        d="M280.692 141.786c-14.721 11.511-43.897 47.025-54.425 54.252-3.123 2.142-4.64 4.016-7.941.446l-29.532-27.572c6.87 7.763 14.989 24.271 14.008 47.828-.803 19.363-9.101 34.175-22.127 29.089 13.204 7.584 25.071 16.329 36.224 14.098 19.807-4.015 49.786-49.88 61.83-72.812 12.045-22.932 23.198-59.784 1.963-45.329z"
        fill="url(#prefix__paint10_linear)"
      />
      <path
        d="M393.647 221.558c-1.606-12.671 6.514-13.92 21.592-12.135 15.079 1.784 24.625 1.338 31.942 19.184 4.907 11.868 26.766 71.384 40.774 109.664 5.889 15.972-5.978 33.015-23.019 33.015H402.48l-8.833-149.728z"
        fill="url(#prefix__paint11_linear)"
      />
      <path
        d="M454.943 246.988c-.982-2.498-1.785-4.55-2.32-5.889-7.316-17.846-16.863-17.31-31.941-19.184-12.848-1.517-25.518-.446-26.588 7.584 0 0 23.108-.803 28.907-.089 14.99 1.785 24.536 1.428 31.763 18.828.09-.446.179-.893.179-1.25z"
        fill="url(#prefix__paint12_linear)"
      />
      <path
        d="M429.961 276.792l17.933 59.07c2.499 8.388 10.261 14.098 19.005 14.098h4.372c13.829 0 23.465-13.83 18.558-26.858l-22.306-59.07c-3.39-8.923-12.58-14.188-21.948-12.492-11.778 1.963-19.094 13.83-15.614 25.252z"
        fill="url(#prefix__paint13_linear)"
      />
      <path
        d="M352.784 115.731c22.841.357 27.659 6.336 30.871 28.643 3.212 22.308 23.108 183.011 23.108 183.011h-46.752l-1.606-183.011-5.621-28.643z"
        fill="url(#prefix__paint14_linear)"
      />
      <path
        d="M378.48 310.163c-2.855-13.652-5.8-27.304-8.744-40.956-2.944-13.563-5.621-27.215-8.565-40.778v-.09c-.268-1.249-2.053-.981-2.053.179l.893 98.778h21.948a580.815 580.815 0 00-3.479-17.133z"
        fill="url(#prefix__paint15_linear)"
      />
      <path
        d="M292.916 239.046c29.354.447 39.257-2.23 47.198-11.867 16.417-19.809 30.336-84.055 31.852-97.886 1.517-13.83-23.822-19.006-55.674-6.692s-41.934 22.129-48.091 37.031c-6.156 14.901 0 60.855 0 60.855s-7.405 4.104-1.784 12.313c2.052 2.32 14.097 6.068 26.499 6.246z"
        fill="url(#prefix__paint16_linear)"
      />
      <path
        d="M292.916 239.046c29.354.447 39.257-2.23 47.198-11.867 16.417-19.809 30.336-84.055 31.852-97.886 1.517-13.83-23.822-19.006-55.674-6.692s-41.934 22.129-48.091 37.031c-6.156 14.901 0 60.855 0 60.855s-7.405 4.104-1.784 12.313c2.052 2.32 14.097 6.068 26.499 6.246z"
        fill="url(#prefix__paint17_linear)"
      />
      <path
        d="M340.114 178.905c1.874-8.298 1.428-22.664-4.729-15.704 1.606-9.012 1.071-13.028-18.379-15.972-7.138-1.071-11.956-10.619-15.168-18.56-20.7 9.726-21.413 18.56-26.499 30.963-6.156 14.901-7.138 60.855-7.138 60.855s-3.301 1.873-3.836 5.532c5.442 3.123 15.97 4.64 28.729 4.372 17.845-.357 28.64 0 37.027-15.08s15.257-37.655 9.993-36.406z"
        fill="url(#prefix__paint18_linear)"
      />
      <path
        d="M340.025 158.562s-1.16 1.428-3.034 3.658c-1.962 2.32-4.639 5.533-7.762 9.102-6.245 7.138-14.543 15.704-21.413 21.95-6.87 6.246-16.239 13.653-24.269 18.828-2.052 1.249-3.925 2.498-5.621 3.48-1.784.981-3.301 1.963-4.639 2.677a205.45 205.45 0 01-4.283 2.23c-.892.447-1.338-.446-.535-.981 0 0 1.517-.892 4.104-2.409 1.249-.803 2.766-1.696 4.461-2.766 1.695-1.071 3.48-2.32 5.532-3.659 7.852-5.354 16.952-12.849 23.733-19.095 6.87-6.157 15.168-14.545 21.681-21.504 3.212-3.48 5.978-6.604 8.03-8.834 1.963-2.231 3.123-3.569 3.123-3.569.803-.447 1.517.089.892.892zM329.051 186.579s-4.551 4.64-7.673 7.406c-3.123 2.767-8.298 6.693-8.298 6.693-.179.089-.803-.625-.714-.803 0 0 4.55-4.64 7.673-7.407 3.123-2.766 8.298-6.692 8.298-6.692.178-.089.803.625.714.803zM309.243 166.77s-1.16 2.499-2.944 5.622c-1.784 3.212-4.104 7.049-6.156 9.904-2.052 2.856-4.818 6.425-7.227 9.191a155.064 155.064 0 01-4.283 4.729c-.268.268-.981-.446-.803-.714 0 0 1.695-2.141 3.926-4.996 2.141-2.856 4.729-6.514 6.781-9.37a255.31 255.31 0 006.513-9.547 308.55 308.55 0 003.39-5.354c.09-.268.893.178.803.535z"
        fill="#172845"
      />
      <path
        d="M341.988 103.238c-1.249 4.729-19.361 4.551-45.057-2.231-25.696-6.781-40.329-16.507-39.169-21.236.893-3.391 17.934-2.588 43.63 4.193 25.785 6.782 41.845 14.545 40.596 19.274z"
        fill="url(#prefix__paint19_linear)"
      />
      <path
        d="M286.313 82.894c-10.974 9.369-14.989 21.95-11.063 30.516-8.298 12.225-1.338 23.646 12.937 24.985 17.131 1.695 13.651-14.723 13.651-14.723 5.71-5.979 3.837-11.243-2.677-16.865 3.48-5.532-.624-15.794-.624-15.794l-12.224-8.12z"
        fill="url(#prefix__paint20_linear)"
      />
      <path
        d="M332.441 123.851c-5.442-.625-10.171 3.747-19.629 12.403-6.781 6.246-14.454 7.227-11.42-.982-3.391-12.135-6.513-23.111-6.513-23.111s-15.525-24.716-11.778-39.885c3.748-15.08 44.433 18.024 44.433 18.024s-10.082 18.292 4.907 33.551z"
        fill="url(#prefix__paint21_linear)"
      />
      <path
        d="M296.752 118.854c12.759-7.228 13.83-16.151 16.149-16.686 5.889-1.249 2.499 12.224 7.674 9.369 1.338-.803 2.676-1.606 4.015-2.498.803 4.729 3.033 9.904 7.851 14.723-5.442-.625-10.171 3.747-19.629 12.403-6.781 6.246-14.454 7.227-11.42-.982-1.785-6.157-3.48-12.046-4.64-16.329z"
        fill="url(#prefix__paint22_linear)"
      />
      <path
        d="M316.738 134.291l-.535.803c-.357.446-.803 1.071-1.428 1.784-1.249 1.339-3.123 2.767-4.729 3.57-1.606.803-3.925 1.338-5.71 1.517-.892.089-1.695.089-2.32 0-.535-.09-.892-.09-.892-.09-.178 0-.089-.981 0-1.07 0 0 .357 0 .892-.09.536-.089 1.249-.178 2.142-.357 1.695-.356 3.658-1.07 5.085-1.784 1.428-.714 3.302-1.785 4.551-2.856.624-.535 1.16-1.07 1.606-1.427l.624-.625c.089-.089.803.446.714.625z"
        fill="#172845"
      />
      <path
        d="M280.246 69.063c4.104-16.597 48.894 19.809 48.894 19.809s-2.855 5.264-3.569 12.581c-1.338.625-2.587 1.25-3.926 1.874-9.1 4.283-18.558 8.209-28.551 9.548-4.639 0-7.762-.625-10.528-1.874-2.766-1.249-6.424-25.252-2.32-41.938z"
        fill="url(#prefix__paint23_linear)"
      />
      <path
        d="M309.243 78.879c-8.297 11.867-8.565 29.624-2.676 36.941-9.369 12.046.446 32.837 13.829 27.661 11.153-4.372 12.313-20.255 21.681-25.341 4.104-7.228-2.052-9.726-10.26-11.867 1.962-6.247-4.64-15.17-4.64-15.17L309.243 78.88z"
        fill="url(#prefix__paint24_linear)"
      />
      <path
        d="M317.006 121.263s-1.963-3.48 1.07-8.387c-4.55-6.157-5.621-17.847-4.728-31.231l-4.015-2.766c-8.298 11.867-8.566 29.624-2.677 36.941-9.368 12.046.446 32.837 13.829 27.661 2.588-.981 4.551-2.587 6.335-4.55-15.881-2.231-9.814-17.668-9.814-17.668z"
        fill="url(#prefix__paint25_linear)"
      />
      <path
        d="M301.481 84.054c-23.465-6.157-39.258-7.496-43.629-4.194 4.014-6.068 20.431-14.544 26.766-16.24 25.25 3.302 39.704 13.92 46.842 21.058 7.137 7.139 10.349 17.133 10.349 17.133-2.498-5.087-17.219-11.69-40.328-17.757z"
        fill="#172845"
      />
      <path
        d="M278.373 65.94c4.728-14.455 11.688-19.72 19.985-20.969 8.298-1.25 26.499 8.745 30.96 19.81 3.034 7.405 1.963 21.86 1.963 21.86s-42.737-11.6-52.908-20.7z"
        fill="#172845"
      />
      <path
        d="M278.373 65.94c4.729-14.455 11.688-19.72 19.986-20.969 8.297-1.25 26.499 8.745 30.96 19.81 2.319 5.71 2.23 15.614 2.052 19.897 7.137 7.05 10.349 17.133 10.349 17.133-2.498-4.997-17.13-11.6-40.328-17.757-23.465-6.157-39.258-7.495-43.629-4.194 3.122-4.64 13.204-10.53 20.61-13.92z"
        fill="url(#prefix__paint26_linear)"
      />
      <path
        d="M348.055 272.24c35.51-9.191 52.998-12.581 73.162-20.969 9.725-4.015 12.58-5.354 22.395-11.421 10.796-6.693 49.696 27.483 38.276 36.495-31.674 24.806-89.579 69.51-104.301 77.184-20.521 10.618-67.005 17.043-78.872 17.043-19.004-39.886 13.74-89.141 49.34-98.332z"
        fill="url(#prefix__paint27_linear)"
      />
      <path
        d="M309.868 300.17s-1.338 1.963-3.569 5.264c-2.141 3.302-5.175 8.031-7.316 13.831-1.071 2.945-1.874 6.157-2.231 9.458-.357 3.302-.178 6.871.803 10.083v.179l.09.268.178.624.357 1.249.089.268c0 .089.179.268 0 .179h-1.874c-.981 0-1.962 0-3.033-.09-1.785 0-3.48-.089-5.175-.089-3.39-.089-6.692-.089-9.814-.178-.803 0-1.517 0-2.32-.09h-.982l-.089-.089c-.178-.178-.268-.268-.357-.446l-.178-.178-.089-.09c-.268-.357-.536-.714-.714-1.07-.982-1.428-1.695-3.034-2.32-4.64a33.33 33.33 0 01-1.517-5.087c-.178-.803-.446-1.695-.624-2.498a26.307 26.307 0 00-.714-2.498 75.147 75.147 0 00-3.658-9.726c-1.428-3.124-3.123-5.979-4.907-8.567-3.48-5.175-7.673-8.923-10.796-11.243-.803-.624-1.517-1.07-2.142-1.516-.624-.357-1.159-.804-1.695-1.071a50.597 50.597 0 00-1.517-.803c-1.159-.625-.713-1.517.447-.982 0 0 .535.268 1.516.803.536.268 1.071.625 1.785.982.714.446 1.427.892 2.32 1.427 3.301 2.32 7.673 6.068 11.331 11.333a58.465 58.465 0 015.175 8.655 73.8 73.8 0 013.925 9.905c.268.892.536 1.695.803 2.587.179.893.446 1.696.625 2.588.446 1.695.892 3.301 1.517 4.818a31.865 31.865 0 002.141 4.283c.178.357.446.625.625.893l.089.089h.089c.803 0 1.606 0 2.32.089 3.123.089 6.424.179 9.814.268 1.695 0 3.48.089 5.175.178.714 0 1.517 0 2.231.089h.089l-.089-.267c-.982-3.569-1.071-7.317-.625-10.797.446-3.48 1.338-6.871 2.498-9.815 2.409-5.979 5.532-10.708 7.763-14.009 2.23-3.302 3.658-5.176 3.658-5.176.892-.981 1.606-.446.892.625z"
        fill="#172845"
      />
      <path
        d="M323.43 320.424c-11.956 7.942-19.54 50.772 12.223 50.772h72.181s10.706-4.461 19.539-11.51c8.833-6.96-88.776-48.988-88.776-48.988l-15.167 9.726z"
        fill="url(#prefix__paint28_linear)"
      />
      <path
        d="M262.848 336.308c.268-3.301-2.409-5.354-8.655-4.818-1.249.089-2.765.178-4.104.267-2.23.179-4.372-.357-6.245-1.606-2.945-1.874-8.209-4.729-14.99-5.621-5.977 0-10.795 8.387-17.755 9.101-6.959.714-15.078-12.224-38.365-10.083-23.287 2.142-31.139 27.305-30.96 34.532.267 7.228 3.122 13.117 18.915 13.117h102.337l-.178-34.889z"
        fill="url(#prefix__paint29_linear)"
      />
      <path
        d="M298.091 346.837c-1.071-11.421-1.606-19.631-10.707-17.935-9.101 1.695-24.447 7.406-24.447 7.406s-.714 6.246-16.506 7.406c6.246 6.692 6.692 13.92 7.227 19.631.446 5.71-1.874 7.763 0 7.763s31.942-.536 36.581-.536c4.64 0 9.815-2.588 7.852-23.735z"
        fill="url(#prefix__paint30_linear)"
      />
      <path
        d="M287.384 328.901c-7.852 1.428-20.164 5.889-23.555 7.139 0 .803 0 1.606.09 2.409.713-.179 6.78-2.142 8.565-1.339 2.23.893-.714 7.853 0 7.317 9.368-7.138 12.669-12.849 17.131-13.295 2.23-.178 4.461.625 6.067 1.695-1.428-3.212-3.837-4.729-8.298-3.926z"
        fill="url(#prefix__paint31_linear)"
      />
      <path
        d="M323.43 320.425c-11.956 8.209-34.618 17.667-34.618 17.667s-6.603 17.043 1.249 32.569c24.268-5.621 100.91-25.074 100.91-25.074s-40.596-42.384-52.374-34.799c-11.777 7.584-15.167 9.637-15.167 9.637z"
        fill="url(#prefix__paint32_linear)"
      />
      <path
        d="M288.276 345.231c6.603-1.071 13.205-2.409 19.54-4.64 3.301-1.16 6.602-2.588 9.725-4.283 2.32-1.16 4.461-2.499 6.424-4.194 1.428-1.339 2.855-2.766 3.837-4.462.803-1.249 1.427-2.766 1.338-4.283-.089-2.409-2.141-3.301-4.461-3.658-.892.625-1.249.803-1.249.803-11.956 8.209-34.618 17.668-34.618 17.668s-1.071 2.855-1.874 7.316a3.586 3.586 0 011.338-.267z"
        fill="url(#prefix__paint33_linear)"
      />
      <path
        d="M492.327 292.049c-20.878 26.769-55.942 67.369-84.493 79.147 4.55-11.243-7.227-12.759-20.878-13.919-13.651-1.16-23.823-6.871-36.67-18.917-15.971-14.991-16.507-20.969-26.856-18.025 0 0 60.046-38.19 87.794-58.178 10.974-7.852 22.395-15.793 32.209-22.396 14.99-10.173 35.065-7.674 47.199 5.8 11.777 13.116 12.491 32.658 1.695 46.488z"
        fill="url(#prefix__paint34_linear)"
      />
      <path
        d="M350.285 338.449c.268.178.447.446.714.625a215.422 215.422 0 0014.276-9.102c5.978-4.015 11.777-8.387 17.309-12.938 5.532-4.551 10.974-9.369 16.06-14.455 5.175-5.087 9.993-10.44 14.632-15.973 4.729-5.71 9.101-11.689 13.205-17.846 1.874-2.766 3.48-5.621 5.353-8.387 1.428-2.142 2.855-4.283 4.015-6.603.982-2.053 2.231-4.73 1.696-7.049-.179-.714-.625-1.428-1.25-1.874-8.029 5.443-16.595 11.51-24.982 17.489-27.748 19.987-87.794 58.178-87.794 58.178 10.171-3.034 10.796 2.944 26.766 17.935z"
        fill="url(#prefix__paint35_linear)"
      />
      <path
        d="M130.71 157.669c.536 4.462 2.409 6.603 6.157 9.905 3.747 3.212 18.379 6.781 26.32 8.119 6.87 1.16 26.41.179 21.681-10.529-4.729-10.707-21.592-12.76-21.592-12.76s-33.101-.713-32.566 5.265z"
        fill="url(#prefix__paint36_linear)"
      />
      <path
        d="M167.648 158.74c4.104 4.461 13.562 3.212 13.562 3.212l9.279 11.868s1.963-.268-2.32-5.711c-4.282-5.443-10.26-12.582-10.26-12.582l-10.261 3.213z"
        fill="url(#prefix__paint37_linear)"
      />
      <path
        d="M198.073 111.359c7.933 0 14.365-6.432 14.365-14.366 0-7.934-6.432-14.366-14.365-14.366-7.934 0-14.365 6.432-14.365 14.366 0 7.934 6.431 14.366 14.365 14.366z"
        fill="url(#prefix__paint38_radial)"
      />
      <path
        d="M198.697 93.692l1.071 1.784 2.052.536c.625.178.803.892.357 1.338l-1.428 1.517.179 2.141c.089.625-.535 1.071-1.16.804l-1.874-.893-1.873.893c-.536.267-1.16-.179-1.16-.804l.178-2.141-1.427-1.517c-.446-.446-.179-1.16.357-1.338l2.052-.536 1.07-1.784c.625-.536 1.339-.536 1.606 0z"
        fill="#E7AD80"
      />
      <path
        d="M198.697 93.692l1.071 1.784 2.052.536c.625.178.803.892.357 1.338l-1.428 1.517.179 2.141c.089.625-.535 1.071-1.16.804l-1.874-.893-1.873.893c-.536.267-1.16-.179-1.16-.804l.178-2.141-1.427-1.517c-.446-.446-.179-1.16.357-1.338l2.052-.536 1.07-1.784c.625-.536 1.339-.536 1.606 0z"
        fill="url(#prefix__paint39_radial)"
      />
      <path
        d="M229.568 147.586l-2.409 8.655-116.791-7.049-45.504-60.498 2.32-9.28h31.763a35.811 35.811 0 0123.109 8.477l5.531-3.302c5.621-3.39 11.956-5.175 18.559-5.175h38.9l44.522 68.172z"
        fill="url(#prefix__paint40_linear)"
      />
      <path
        d="M181.656 87.98H129.55c-.089 0-.178 0-.357.09-5.442 2.052-10.082 2.32-13.918.089-.179-.09-.268-.09-.446-.09H63.972c-.714 0-1.16.804-.803 1.428l44.165 67.548c.268.446.803.713 1.338.713h117.595c.714 0 1.16-.803.803-1.427l-44.165-67.547c-.178-.536-.625-.803-1.249-.803z"
        fill="url(#prefix__paint41_linear)"
      />
      <path
        d="M174.964 157.669c-5.353 2.677-10.082 2.677-14.275 0L115.186 87.98c3.836 2.41 8.654 2.231 14.275 0l45.503 69.689z"
        fill="url(#prefix__paint42_linear)"
      />
      <path
        d="M156.674 152.404s-7.316-10.172-11.778-16.953c-4.461-6.782-10.974-17.489-10.974-17.489-.178-.357.625-.893.892-.625 0 0 7.317 10.172 11.778 16.954 4.461 6.781 10.974 17.489 10.974 17.489.178.446-.625.981-.892.624z"
        fill="#172845"
      />
      <path
        d="M131.424 160.257c-2.409-4.73-.178-25.163 1.249-29.803 1.428-4.64 5.621-5.622 6.335.535.714 6.157 1.16 18.292 1.963 25.163.892 6.96-6.692 9.637-9.547 4.105z"
        fill="url(#prefix__paint43_linear)"
      />
      <path
        d="M137.669 155.528c2.231-6.157 8.744-19.095 12.492-23.735 3.836-4.64 7.048-1.785 6.156 2.677-.803 4.461-5.889 19.63-8.298 25.252-2.409 5.532-14.186 6.067-10.35-4.194z"
        fill="url(#prefix__paint44_linear)"
      />
      <path
        d="M145.253 159.632c1.249-6.96 9.101-22.843 11.064-25.252 1.963-2.409 5.532-.357 4.907 3.747-.714 4.105-3.926 18.471-5.71 23.468-1.785 5.086-11.599 5.621-10.261-1.963z"
        fill="url(#prefix__paint45_linear)"
      />
      <path
        d="M153.194 161.06c3.837-11.957 6.157-17.4 9.101-17.846 2.944-.446 2.855 5.086 2.141 9.815-.714 4.729-2.052 12.492-3.212 14.991-1.07 2.32-10.439.535-8.03-6.96z"
        fill="url(#prefix__paint46_linear)"
      />
      <path
        d="M229.568 212.278c7.762 9.191-3.033-7.495 1.963-7.228 11.42.625 2.409-3.123 6.156-7.406 11.332-12.938 30.871-39.261 41.132-47.113 8.208-6.246 3.212-5.533 7.762-12.046-1.517-.268-3.837 1.784-5.978 3.301-14.721 11.511-43.897 47.024-54.425 54.252-3.123 2.142-4.64 4.015-7.941.446l-29.533-27.572c13.205 12.225 33.102 34.175 40.864 43.366z"
        fill="url(#prefix__paint47_linear)"
      />
      <path
        d="M236.438 210.582s-.713-.714-1.606-1.517a77.882 77.882 0 00-3.212-2.498c-.981-.714-2.23-1.695-3.301-2.32-1.071-.714-1.963-1.16-1.963-1.16-.089-.089.268-.982.357-.982 0 0 .982.268 2.231.714 1.249.446 2.765 1.25 3.836 2.053 1.071.803 2.231 2.052 3.123 3.123a25.416 25.416 0 011.338 1.963c.089.178-.624.714-.803.624zM372.323 147.586s-1.07 2.587-2.409 6.067c-1.338 3.48-2.855 7.853-4.104 11.243a336.045 336.045 0 00-3.926 11.333c-1.16 3.569-2.052 6.246-2.052 6.246-.089.357-1.07.089-1.07-.268 0 0 .624-2.766 1.516-6.425.982-3.658 2.32-8.119 3.48-11.599 1.249-3.48 3.034-7.763 4.55-11.154 1.517-3.391 2.855-5.979 2.855-5.979.447-.178 1.25.179 1.16.536zM173.001 176.051s-.892.268-2.052.535c-1.16.268-2.676.446-3.836.446-1.16 0-2.677-.178-3.837-.357-1.16-.267-2.052-.446-2.052-.446-.089 0 0-1.07.179-1.07h2.052c1.16 0 2.587-.09 3.658-.09 1.07 0 2.498 0 3.658.09h2.052c.178-.09.268.803.178.892zM150.785 162.844s.268-1.517.803-3.48 1.428-4.283 2.231-6.067c.803-1.785 2.141-3.926 3.301-5.622 1.16-1.695 2.141-2.855 2.141-2.855.179-.179.982.446.892.624 0 0-.713 1.339-1.695 3.034-.892 1.785-1.963 3.926-2.766 5.711-.803 1.695-1.873 3.926-2.676 5.711-.803 1.784-1.339 3.212-1.339 3.212 0 .178-.892-.089-.892-.268zM144.183 159.186s.535-1.963 1.427-4.551 2.052-5.711 3.123-8.12c1.071-2.409 2.677-5.354 4.015-7.674 1.338-2.32 2.409-4.015 2.409-4.015.178-.268 1.071.268.892.535 0 0-.892 1.874-1.963 4.283-1.16 2.41-2.409 5.443-3.479 7.853-1.071 2.32-2.499 5.353-3.569 7.852a385.08 385.08 0 00-1.874 4.283c-.178.089-1.071-.179-.981-.446zM136.956 156.152s0-.713.089-1.606c.089-.892.357-2.052.624-2.944.357-.803.893-1.874 1.517-2.588.536-.714 1.071-1.249 1.071-1.249.089-.089.892.446.892.535 0 0-.268.625-.535 1.428-.268.803-.625 1.785-.892 2.588-.357.803-.714 1.695-1.071 2.498-.357.803-.535 1.428-.535 1.428-.268.178-1.071.089-1.16-.09zM284.707 320.871s-.089-1.517-.089-4.194c-.089-2.588-.089-6.246 0-10.351.089-8.298.803-18.56 1.874-26.501.981-8.031 2.944-18.114 4.907-26.144.981-4.016 1.963-7.496 2.587-9.994.714-2.499 1.16-4.016 1.16-4.016.268-.803 1.249-.535 1.071.268 0 0-.357 1.517-.981 4.015-.625 2.499-1.428 6.068-2.32 10.083-1.695 8.031-3.301 18.114-4.372 26.056-.982 7.941-1.963 18.113-2.32 26.322-.178 4.105-.268 7.674-.357 10.262v4.104c-.267.893-1.16.893-1.16.09z"
        fill="#172845"
      />
      <path
        d="M285.064 291.335s-.267.179-.892.268c-.535.178-1.428.178-2.409.089-2.052-.268-4.907-1.517-6.959-4.105a8.66 8.66 0 01-1.339-2.141 17.532 17.532 0 01-.535-1.249 1.686 1.686 0 01-.178-.714c-.09-.268-.09-.446-.09-.714-.178-1.785 0-3.569.179-5.265.357-3.479.981-6.87 1.517-9.815 1.159-5.889 3.122-13.384 4.996-19.273.892-2.945 1.784-5.533 2.498-7.317.714-1.785 1.16-2.945 1.16-2.945.268-.625 1.16-.178.982.357 0 0-.447 1.071-.982 2.945-.624 1.784-1.338 4.372-2.141 7.406-1.606 5.889-3.301 13.384-4.461 19.273-.625 2.945-1.249 6.246-1.696 9.637-.178 1.696-.356 3.391-.356 4.908 0 .178 0 .357.089.535.089.179 0 .268.089.446.089.357.268.714.446 1.071.268.714.714 1.339 1.071 1.874 1.695 2.32 4.104 3.569 5.888 3.837.893.089 1.606.089 2.053 0 .446-.089.713-.179.713-.179.625 0 .982.803.357 1.071z"
        fill="#172845"
      />
      <path
        d="M254.193 331.49c-1.249.089-2.765.178-4.104.267-2.23.179-4.372-.357-6.245-1.606-2.945-1.874-8.209-4.729-14.99-5.621-5.977 0-10.795 8.387-17.755 9.101-6.959.714-15.078-12.224-38.365-10.083-9.725.892-16.774 5.889-21.681 11.779 9.457-8.031 28.194-9.905 51.392.624 19.093 8.655 30.87 10.797 29.264 4.997-1.605-5.8 3.302-3.301 15.704-5.265 12.58-1.963 15.435.625 15.435.625.357-3.301-2.409-5.354-8.655-4.818z"
        fill="url(#prefix__paint48_linear)"
      />
      <path
        d="M427.016 354.6s0-.089.09-.357c0-.267.089-.535.178-.981.089-.893.089-2.142-.268-3.748-.356-1.606-1.159-3.391-2.409-5.175a15.542 15.542 0 00-2.319-2.588c-.893-.803-1.963-1.517-3.034-2.141-2.23-1.25-4.907-2.142-7.762-2.677-2.855-.536-5.8-.803-8.744-.893-5.978-.267-12.134-.357-17.309-2.141-2.587-.803-5.264-2.142-7.762-3.659-2.499-1.606-4.908-3.48-7.227-5.353-4.64-3.837-9.101-7.942-13.651-10.619-2.32-1.338-4.551-2.409-6.692-3.034-2.141-.713-4.104-1.07-5.71-1.16h-1.16c-.357 0-.714 0-1.071.09-.624 0-1.16.089-1.606.178-.446.089-.803.089-.981.179-.268.089-.357.089-.357.089-1.071.267-1.338-.714-.268-1.071 0 0 .09 0 .357-.089a9.282 9.282 0 011.071-.268 27.718 27.718 0 011.784-.268c.357 0 .714-.089 1.071-.089h1.249c1.785.089 3.837.357 6.067 1.071 2.231.625 4.64 1.695 7.049 3.034 2.409 1.338 4.818 3.034 7.137 4.818 2.32 1.785 4.64 3.748 6.96 5.622 4.639 3.747 9.547 7.138 14.454 8.566 4.818 1.606 10.796 1.784 16.773 2.141 3.034.179 6.068.536 9.012 1.16 2.944.625 5.799 1.606 8.208 3.034a18.54 18.54 0 013.302 2.409 14.17 14.17 0 012.409 2.856c1.338 1.963 2.141 3.926 2.498 5.71.357 1.785.267 3.213.178 4.194-.089.446-.178.893-.178 1.071-.089.268-.089.357-.089.357-.714 1.16-1.517.803-1.25-.268zM179.069 294.905s-8.923-4.818-14.544-8.209-14.008-9.102-14.008-9.102c-.267-.178.268-1.07.536-.892 0 0 8.922 4.819 14.543 8.209 5.621 3.391 14.008 9.102 14.008 9.102.268.267-.179 1.071-.535.892zM183.797 368.341s.268-.446.714-1.16c.446-.714.982-1.784 1.606-3.034 1.249-2.498 2.32-5.71 3.034-8.298.713-2.588 1.427-5.889 1.695-8.655.089-1.339.178-2.588.178-3.48v-1.428c0-.268.982-.357 1.071-.089 0 0 .089.535.178 1.427.09.893.179 2.142.09 3.57 0 2.855-.536 6.424-1.25 9.101-.713 2.677-2.23 5.979-3.658 8.477a27.597 27.597 0 01-1.963 2.945c-.535.713-.892 1.16-.892 1.16-.178.267-.892-.268-.803-.536zM189.686 325.51s-.268 0-.803-.089-1.249 0-2.231 0c-1.873.179-4.55.625-7.494 1.606-5.8 1.963-12.402 6.068-16.863 9.994-2.231 1.963-4.461 4.462-6.246 7.406-1.784 2.855-3.033 6.068-3.836 9.012-.803 2.945-.982 5.622-1.071 7.585 0 .981 0 1.695.089 2.231 0 .535.089.803.089.803 0 .624-.981.714-1.07.089 0 0 0-.268-.089-.803-.09-.535-.09-1.339-.179-2.32-.089-1.963 0-4.819.714-7.942s1.874-6.513 3.747-9.636c1.785-3.123 4.194-5.89 6.513-7.942 4.64-4.194 11.599-8.209 17.756-9.994 3.033-.892 5.888-1.338 7.851-1.338.982 0 1.785 0 2.409.089.535.089.892.089.892.089.536.268.447 1.16-.178 1.16zM266.417 368.877s-.179-.357-.446-.982c-.268-.624-.536-1.427-.803-2.498-.536-2.052-.625-4.64-.446-6.692.267-2.053 1.07-4.551 2.052-6.336.535-.892.981-1.695 1.338-2.23.357-.536.625-.804.625-.804.178-.178.981.447.892.625l-.446.892a31.58 31.58 0 00-.982 2.231c-.713 1.785-1.249 4.105-1.427 5.979-.268 1.873-.357 4.193-.089 6.156.089.982.267 1.785.356 2.41.179.624.268.981.268.981.089.179-.714.446-.892.268zM401.771 216.083c6.678-4.976 8.894-13.302 4.949-18.597-3.945-5.296-12.556-5.555-19.234-.58-6.678 4.976-8.893 13.302-4.949 18.597 3.945 5.296 12.556 5.555 19.234.58z"
        fill="#172845"
      />
      <path
        d="M150.785 70.403c6.307 0 11.421-5.114 11.421-11.422 0-6.308-5.114-11.421-11.421-11.421-6.307 0-11.42 5.113-11.42 11.421 0 6.308 5.113 11.422 11.42 11.422z"
        fill="url(#prefix__paint49_radial)"
      />
      <path
        d="M151.32 56.304l.803 1.428 1.606.357c.447.09.625.714.357 1.07l-1.07 1.16.178 1.696c.089.446-.446.803-.892.625l-1.517-.714-1.517.714c-.446.178-.981-.179-.892-.625l.179-1.695-1.071-1.16c-.357-.357-.179-.893.357-1.071l1.606-.357.803-1.428c.267-.446.892-.446 1.07 0z"
        fill="#E7AD80"
      />
      <path
        d="M151.32 56.304l.803 1.428 1.606.357c.447.09.625.714.357 1.07l-1.07 1.16.178 1.696c.089.446-.446.803-.892.625l-1.517-.714-1.517.714c-.446.178-.981-.179-.892-.625l.179-1.695-1.071-1.16c-.357-.357-.179-.893.357-1.071l1.606-.357.803-1.428c.267-.446.892-.446 1.07 0z"
        fill="url(#prefix__paint50_radial)"
      />
      <path
        d="M211.01 65.405c6.307 0 11.42-5.113 11.42-11.421 0-6.308-5.113-11.422-11.42-11.422-6.307 0-11.42 5.114-11.42 11.422 0 6.308 5.113 11.421 11.42 11.421z"
        fill="url(#prefix__paint51_radial)"
      />
      <path
        d="M211.545 51.307l.803 1.428 1.606.357c.446.09.625.714.357 1.07l-1.07 1.16.178 1.696c.089.446-.446.803-.892.625l-1.517-.714-1.517.714c-.446.178-.981-.179-.892-.625l.178-1.695-1.07-1.16c-.357-.357-.179-.893.357-1.071l1.606-.357.803-1.428c.178-.446.803-.446 1.07 0z"
        fill="#E7AD80"
      />
      <path
        d="M211.545 51.307l.803 1.428 1.606.357c.446.09.625.714.357 1.07l-1.07 1.16.178 1.696c.089.446-.446.803-.892.625l-1.517-.714-1.517.714c-.446.178-.981-.179-.892-.625l.178-1.695-1.07-1.16c-.357-.357-.179-.893.357-1.071l1.606-.357.803-1.428c.178-.446.803-.446 1.07 0z"
        fill="url(#prefix__paint52_radial)"
      />
      <path
        d="M237.955 98.51a8.298 8.298 0 008.298-8.299 8.298 8.298 0 10-16.596 0 8.298 8.298 0 008.298 8.299z"
        fill="url(#prefix__paint53_radial)"
      />
      <path
        d="M238.312 88.249l.624.981 1.16.268c.357.09.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.624.445l-1.071-.535-1.071.535c-.357.179-.713-.089-.624-.446l.089-1.249-.803-.892c-.268-.268-.089-.714.268-.714l1.16-.268.624-.981c.089-.268.535-.268.714 0z"
        fill="#E7AD80"
      />
      <path
        d="M238.312 88.249l.624.981 1.16.268c.357.09.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.624.445l-1.071-.535-1.071.535c-.357.179-.713-.089-.624-.446l.089-1.249-.803-.892c-.268-.268-.089-.714.268-.714l1.16-.268.624-.981c.089-.268.535-.268.714 0z"
        fill="url(#prefix__paint54_radial)"
      />
      <path
        d="M185.582 32.569a8.298 8.298 0 008.297-8.299 8.298 8.298 0 10-16.595 0 8.298 8.298 0 008.298 8.299z"
        fill="url(#prefix__paint55_radial)"
      />
      <path
        d="M186.028 22.397l.624.981 1.16.268c.357.089.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.624.445l-1.071-.535-1.071.535c-.357.179-.713-.089-.624-.446l.089-1.249-.803-.892c-.268-.268-.089-.714.268-.714l1.16-.268.624-.981c.089-.357.535-.357.714 0z"
        fill="#E7AD80"
      />
      <path
        d="M186.028 22.397l.624.981 1.16.268c.357.089.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.624.445l-1.071-.535-1.071.535c-.357.179-.713-.089-.624-.446l.089-1.249-.803-.892c-.268-.268-.089-.714.268-.714l1.16-.268.624-.981c.089-.357.535-.357.714 0z"
        fill="url(#prefix__paint56_radial)"
      />
      <path fill="url(#prefix__pattern0)" d="M166.074 41.849h55.496v50.593h-55.496z" />
      <g filter="url(#prefix__filter0_f)" strokeMiterlimit={10}>
        <path d="M221.003 91.728L200.66 75.13l-13.294-31.498-19.718 25.43 33.012 6.246" stroke="#E7AD80" />
        <path d="M221.003 91.728L200.66 75.13l-13.294-31.498-19.718 25.43 33.012 6.246" stroke="#E7AD80" />
        <path d="M221.003 91.728L200.66 75.13l-13.294-31.498-19.718 25.43 33.012 6.246" stroke="#E7AF83" />
      </g>
      <path d="M221.003 91.728L200.66 75.13l-13.294-31.498-19.718 25.43 33.012 6.246" stroke="#E7AD80" strokeMiterlimit={10} />
      <path d="M187.366 47.291a3.658 3.658 0 100-7.316 3.658 3.658 0 000 7.316z" fill="url(#prefix__paint57_radial)" />
      <path d="M187.366 44.704a1.071 1.071 0 100-2.142 1.071 1.071 0 000 2.142z" fill="#E7AD80" />
      <path d="M187.366 44.704a1.071 1.071 0 100-2.142 1.071 1.071 0 000 2.142z" fill="url(#prefix__paint58_radial)" />
      <path d="M208.779 27.928a3.659 3.659 0 100-7.317 3.659 3.659 0 000 7.317z" fill="url(#prefix__paint59_radial)" />
      <path d="M208.779 25.34a1.07 1.07 0 100-2.14 1.07 1.07 0 000 2.14z" fill="#E7AD80" />
      <path d="M208.779 25.34a1.07 1.07 0 100-2.14 1.07 1.07 0 000 2.14z" fill="url(#prefix__paint60_radial)" />
      <path d="M167.648 74.328a5.264 5.264 0 10-.001-10.529 5.264 5.264 0 00.001 10.529z" fill="url(#prefix__paint61_radial)" />
      <path d="M167.648 70.58a1.517 1.517 0 100-3.033 1.517 1.517 0 000 3.034z" fill="#E7AD80" />
      <path d="M167.648 70.58a1.517 1.517 0 100-3.033 1.517 1.517 0 000 3.034z" fill="url(#prefix__paint62_radial)" />
      <path d="M200.66 78.79a3.658 3.658 0 100-7.316 3.658 3.658 0 000 7.316z" fill="url(#prefix__paint63_radial)" />
      <path d="M200.66 76.202a1.07 1.07 0 100-2.141 1.07 1.07 0 000 2.141z" fill="#E7AD80" />
      <path d="M200.66 76.202a1.07 1.07 0 100-2.141 1.07 1.07 0 000 2.141z" fill="url(#prefix__paint64_radial)" />
      <path d="M121.788 78.433a6.513 6.513 0 100-13.027 6.513 6.513 0 000 13.027z" fill="url(#prefix__paint65_radial)" />
      <path d="M121.788 73.793a1.874 1.874 0 100-3.748 1.874 1.874 0 000 3.748z" fill="#E7AD80" />
      <path d="M121.788 73.793a1.874 1.874 0 100-3.748 1.874 1.874 0 000 3.748z" fill="url(#prefix__paint66_radial)" />
      <path d="M221.003 95.386a3.658 3.658 0 100-7.317 3.658 3.658 0 000 7.317z" fill="url(#prefix__paint67_radial)" />
      <path d="M221.003 92.799a1.071 1.071 0 100-2.143 1.071 1.071 0 000 2.143z" fill="#E7AD80" />
      <path d="M221.003 92.799a1.071 1.071 0 100-2.143 1.071 1.071 0 000 2.143z" fill="url(#prefix__paint68_radial)" />
      <path d="M81.37 70.045a3.658 3.658 0 100-7.316 3.658 3.658 0 000 7.316z" fill="url(#prefix__paint69_radial)" />
      <path d="M81.37 67.458a1.07 1.07 0 100-2.141 1.07 1.07 0 000 2.14z" fill="#E7AD80" />
      <path d="M81.37 67.458a1.07 1.07 0 100-2.141 1.07 1.07 0 000 2.14z" fill="url(#prefix__paint70_radial)" />
      <path fill="url(#prefix__pattern1)" d="M102.593 49.853h27.748v9.994h-27.748z" />
      <g filter="url(#prefix__filter1_f)">
        <path d="M130.086 50.682l-27.213 8.387" stroke="#E7AD80" strokeMiterlimit={10} />
      </g>
      <g filter="url(#prefix__filter2_d)">
        <path d="M130.086 50.682l-27.213 8.387" stroke="#E7AD80" strokeMiterlimit={10} />
      </g>
      <path
        d="M130.086 58.98a8.298 8.298 0 008.297-8.298 8.298 8.298 0 10-16.595 0 8.298 8.298 0 008.298 8.299z"
        fill="url(#prefix__paint71_radial)"
      />
      <path
        d="M130.443 48.809l.624.981 1.16.268c.357.09.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.625.445l-1.07-.535-1.071.535c-.357.179-.714-.089-.625-.446l.09-1.249-.803-.892c-.268-.268-.09-.714.267-.714l1.16-.268.625-.981c.089-.357.535-.357.714 0z"
        fill="#E7AD80"
      />
      <path
        d="M130.443 48.809l.624.981 1.16.268c.357.09.446.535.268.714l-.803.892.089 1.25c0 .356-.357.624-.625.445l-1.07-.535-1.071.535c-.357.179-.714-.089-.625-.446l.09-1.249-.803-.892c-.268-.268-.09-.714.267-.714l1.16-.268.625-.981c.089-.357.535-.357.714 0z"
        fill="url(#prefix__paint72_radial)"
      />
      <path d="M102.873 62.728a3.658 3.658 0 100-7.317 3.658 3.658 0 000 7.317z" fill="url(#prefix__paint73_radial)" />
      <path d="M102.873 60.14a1.071 1.071 0 100-2.142 1.071 1.071 0 000 2.143z" fill="#E7AD80" />
      <path d="M102.873 60.14a1.071 1.071 0 100-2.142 1.071 1.071 0 000 2.143z" fill="url(#prefix__paint74_radial)" />
      <path
        d="M180.764 0c-22.752.535-69.683 23.646-60.047 36.762 9.636 13.117 47.02-2.766 60.047-10.172 16.952-9.637 24.09-27.215 0-26.59z"
        fill="#172845"
      />
    </g>
    <defs>
      <linearGradient id="prefix__paint0_linear" x1={457.148} y1={148.274} x2={394.211} y2={171.406} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint2_linear" x1={228.35} y1={270.591} x2={353.168} y2={324.776} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint3_linear" x1={238.523} y1={264.96} x2={315.855} y2={350.809} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint4_linear" x1={183.546} y1={246.241} x2={163.35} y2={357.308} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint5_linear" x1={189.803} y1={245.714} x2={158.336} y2={362.58} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint6_linear" x1={170.155} y1={241.497} x2={129.622} y2={428.522} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint7_linear" x1={125.861} y1={180.894} x2={206.149} y2={216.857} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint8_linear" x1={220.666} y1={163.258} x2={168.659} y2={228.498} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint9_linear" x1={246.965} y1={175.717} x2={183.928} y2={227.087} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint10_linear" x1={156.584} y1={87.529} x2={370.74} y2={371.472} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint11_linear" x1={505.292} y1={229.636} x2={440.365} y2={286.67} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint12_linear" x1={354.878} y1={289.345} x2={412.834} y2={246.122} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint13_linear" x1={505.52} y1={244.904} x2={443.625} y2={320.749} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint14_linear" x1={225.464} y1={35.578} x2={439.62} y2={319.522} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint15_linear" x1={326.091} y1={233.585} x2={371.308} y2={291.296} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint16_linear" x1={227.267} y1={71.552} x2={377.281} y2={246.382} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint17_linear" x1={216.333} y1={42.464} x2={430.489} y2={326.408} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint18_linear" x1={264.738} y1={164.454} x2={381.465} y2={246.599} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint19_linear" x1={279.392} y1={121.893} x2={297.633} y2={94.968} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint20_linear" x1={275.432} y1={115.312} x2={316.189} y2={102.213} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint21_linear" x1={269.686} y1={99.342} x2={324.099} y2={110.408} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint22_linear" x1={296.61} y1={131.103} x2={332.393} y2={106.204} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint23_linear" x1={280.984} y1={98.991} x2={330.417} y2={65.947} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint24_linear" x1={294.875} y1={123.343} x2={351.536} y2={89.253} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint25_linear" x1={303.236} y1={119.211} x2={352.936} y2={85.841} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint26_linear" x1={245.906} y1={53.427} x2={308.839} y2={69.938} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint27_linear" x1={322.286} y1={233.696} x2={372.517} y2={295.677} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint28_linear" x1={267.905} y1={289.055} x2={346.788} y2={342.67} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint29_linear" x1={185.253} y1={211.535} x2={206.785} y2={382.234} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint30_linear" x1={259.155} y1={273.732} x2={277.649} y2={372.474} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint31_linear" x1={264.531} y1={295.524} x2={304.179} y2={399.718} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint32_linear" x1={267.505} y1={296.08} x2={370.029} y2={381.681} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint33_linear" x1={289.677} y1={319.828} x2={375.341} y2={383.768} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint34_linear" x1={288.573} y1={225.309} x2={453.606} y2={309.798} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint35_linear" x1={322.29} y1={279.973} x2={446.957} y2={300.883} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint36_linear" x1={182.548} y1={132.872} x2={130.542} y2={198.11} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint37_linear" x1={178.711} y1={164.511} x2={207.155} y2={211.167} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint40_linear" x1={140.26} y1={142.442} x2={159.451} y2={74.271} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint41_linear" x1={279.149} y1={201.899} x2={97.873} y2={94.839} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint42_linear" x1={289.297} y1={195.231} x2={111.909} y2={106.191} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint43_linear" x1={160.361} y1={115.184} x2={108.353} y2={180.424} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint44_linear" x1={168.422} y1={121.611} x2={116.415} y2={186.85} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint45_linear" x1={173.772} y1={125.875} x2={121.764} y2={191.114} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint46_linear" x1={180.576} y1={131.298} x2={128.568} y2={196.538} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint47_linear" x1={254.144} y1={171.914} x2={334.622} y2={246.18} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint48_linear" x1={231.108} y1={260.773} x2={179.822} y2={420.443} gradientUnits="userSpaceOnUse">
        <stop offset={0.094} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <radialGradient
        id="prefix__paint1_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(110.134 0 0 110.144 147.604 110.347)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.192} stopColor="#E7AD80" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint38_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(11.7121 0 0 11.7131 198.349 97.4)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint39_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(7.52018 0 0 7.52085 197.96 96.965)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint49_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(9.28186 0 0 9.28269 151.056 59.273)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint50_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(5.95969 0 0 5.96021 150.747 58.928)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint51_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(9.28185 0 0 9.28269 211.226 54.281)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint52_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(5.95969 0 0 5.96021 210.917 53.936)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint53_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(6.75599 0 0 6.75658 238.111 90.437)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint54_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(4.3379 0 0 4.33827 237.886 90.186)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint55_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(6.75598 0 0 6.75659 185.79 24.518)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint56_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(4.33789 0 0 4.33828 185.565 24.268)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint57_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98715 0 0 2.98742 187.404 43.705)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint58_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(187.327 43.603) scale(1.04425)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint59_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98716 0 0 2.98742 208.843 24.39)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint60_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(208.766 24.288) scale(1.04425)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint61_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(4.30416 0 0 4.30455 167.779 69.186)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint62_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.50465 0 0 1.50478 167.668 69.04)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint63_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98715 0 0 2.98742 200.703 75.232)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint64_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(200.626 75.13) scale(1.04426)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint65_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(5.31763 0 0 5.31811 121.892 72.085)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint66_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1.85904 0 0 1.8592 121.754 71.903)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint67_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98715 0 0 2.98742 221.112 91.821)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint68_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(221.035 91.72) scale(1.04425)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint69_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98715 0 0 2.98742 81.483 66.515)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint70_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(81.406 66.414) scale(1.04426)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint71_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(6.75598 0 0 6.75659 130.229 50.938)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint72_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(4.3379 0 0 4.33827 130.004 50.687)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint73_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(2.98715 0 0 2.98742 102.932 59.138)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint74_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(102.855 59.036) scale(1.04425)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <filter
        id="prefix__filter0_f"
        x={162.752}
        y={38.651}
        width={62.567}
        height={57.464}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="prefix__filter1_f"
        x={98.726}
        y={46.204}
        width={35.507}
        height={17.343}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation={2} result="effect1_foregroundBlur" />
      </filter>
      <filter
        id="prefix__filter2_d"
        x={98.726}
        y={50.204}
        width={35.507}
        height={17.343}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
      <pattern id="prefix__pattern0" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#prefix__image0" />
      </pattern>
      <pattern id="prefix__pattern1" patternContentUnits="objectBoundingBox" width={1} height={1}>
        <use xlinkHref="#prefix__image1" />
      </pattern>
      <image id="prefix__image0" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAA6CAYAAAAHkoFsAAAACXBIWXMAAAsSAAALEgHS3X78AAAA" />
      <image id="prefix__image1" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAANCAYAAADISGwcAAAACXBIWXMAAAsSAAALEgHS3X78AAAA" />
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h500v372H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default PublishCourseImage;
